import { FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Card, CardContent } from "~/components/ui/card";
import { Progress } from "~/components/ui/progress";
interface PlanUsageBarProps {
  pagesUsed: number;
  planPageLimit: number;
}

export const PlanUsageBar: FC<PlanUsageBarProps> = ({
  pagesUsed,
  planPageLimit,
}) => {
  const { formatMessage } = useIntl();
  const usagePercentage = Math.min(
    Math.round((pagesUsed / planPageLimit) * 100),
    100
  );

  const getProgressColor = (percentage: number) => {
    if (percentage < 70) return "bg-blue-600";
    if (percentage < 90) return "bg-yellow-500";
    return "bg-red-500";
  };

  return (
    <Card className="w-full">
      <CardContent className="pt-6">
        <div className="flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <span className="text-sm font-semibold">
              <FormattedMessage
                id="settings.usage.planUsage.title"
                defaultMessage="Monthly AI Computing"
              />
            </span>
            <span className="text-sm text-muted-foreground">
              {usagePercentage}%{" "}
              {formatMessage({
                id: "settings.usage.planUsage.used",
                defaultMessage: "used",
              })}
            </span>
          </div>
          <Progress
            value={usagePercentage}
            className="h-2.5"
            indicatorClassName={getProgressColor(usagePercentage)}
          />
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span>
              <FormattedMessage
                id="settings.usage.planUsage.pagesUsed"
                defaultMessage="Includes document processing, AI chat, reports & transcription"
              />
            </span>
            <span>
              <FormattedMessage
                id="settings.usage.planUsage.resets"
                defaultMessage="Resets at end of billing period"
              />
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
